export const HIDE_SEARCH_BAR = "HIDE_SEARCH_BAR";
export const SHOW_SEARCH_BAR = "SHOW_SEARCH_BAR";

